import React, { Component, Suspense } from "react";
import Select from "react-select";
import MailingSettings from "../components/Einstellungen/MailingSettings";
import MfaSettings from "../components/Einstellungen/MfaSettings";
import MetaFieldsSettings from "../components/Einstellungen/MetaFieldsSettings";
import UpdateNews from "../config/UpdateNews";
import { fetchApi } from "../utils/DatabaseHelper";
import logger from "../logging/logger";

const selectTheme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: "#ffeebe",
        primary: "#ffd370",
    },
});

class Einstellungen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SendMail: {},
            MailSettings: {},
            MfaSettings: {},
            activeTab: "default",
            firmen: [],
            selectedMfaFirma: null,
            selectedMetaFirma: null,
            isSuperAdmin: global.auth?.user?.rolle === "superadmin",
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMfaFirmaChange = this.handleMfaFirmaChange.bind(this);
        this.handleMetaFirmaChange = this.handleMetaFirmaChange.bind(this);
    }

    getInitialMfaFirma() {
        const isSuperAdmin = global.auth?.user?.rolle === "superadmin";
        if (!isSuperAdmin) {
            return {
                value: global.auth?.user?.firmenId || null,
                label: "Meine Firma",
            };
        }

        const currentFilterId = global.filterFirmenId || 0;
        if (currentFilterId !== 0) {
            const match = this.state.firmen.find(
                (f) => f.value === currentFilterId,
            );
            return match || { value: null, label: "Global" };
        }
        return { value: null, label: "Global" };
    }

    async loadFirmen() {
        try {
            const response = await fetchApi("firmen");
            const firmen = (response.data || []).map((firma) => ({
                value: firma.id,
                label: firma.name,
            }));
            this.setState({ firmen });
        } catch (err) {
            logger.error("Firmen konnten nicht geladen werden", err);
        }
    }

    async validate() {
        try {
            const data = await fetchApi("einstellungen");
            const newState = {};
            data.forEach((item) => {
                newState[item.widget] = JSON.parse(item.widget_config);
            });
            this.setState(newState);
        } catch (err) {
            logger.error("err", err);
        }
    }

    async loadMfaSettings(firmaId) {
        const firmenIdQuery =
            firmaId === null || firmaId === undefined
                ? "firmenId=null"
                : `firmenId=${firmaId}`;
        try {
            const data = await fetchApi(
                "einstellungen",
                "MfaSettings",
                `?${firmenIdQuery}`,
            );
            this.setState({ MfaSettings: data });
        } catch (err) {
            this.setState({ MfaSettings: { enabled: false } });
        }
    }

    async componentDidMount() {
        await this.validate();
        if (this.state.isSuperAdmin) {
            await this.loadFirmen();
        }
        const initialFirma = this.getInitialMfaFirma();
        this.setState({
            selectedMfaFirma: initialFirma,
            selectedMetaFirma: initialFirma,
        });
        await this.loadMfaSettings(initialFirma.value);
    }

    async componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            this.validate();
        }
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: { [e.target.id]: e.target.value } });
    }

    async handleMfaFirmaChange(selectedOption) {
        this.setState({ selectedMfaFirma: selectedOption });
        await this.loadMfaSettings(selectedOption.value);
    }

    handleMetaFirmaChange(selectedOption) {
        this.setState({ selectedMetaFirma: selectedOption });
    }

    render() {
        if (
            typeof this.state.SendMail === "undefined" ||
            typeof this.state.MailSettings === "undefined" ||
            typeof this.state.MfaSettings === "undefined"
        ) {
            return (
                <div className="text-center m-5">
                    <h3>Laden...</h3>
                </div>
            );
        }

        const mfaFirmaOptions = [
            { value: null, label: "Global" },
            ...this.state.firmen,
        ];

        // Firmen-Bindung der E-Mail-Templates: nur der Superadmin sieht und
        // setzt sie (Global = instanzweit, gebunden = nur diese Firma)
        const firmenBindungOptions = this.state.isSuperAdmin
            ? [{ value: null, label: "Global (instanzweit)" }, ...this.state.firmen]
            : undefined;

        return (
            <div id="options" className="container-fluid">
                <hr />
                <div className="row">
                    <div className="col-2">
                        {" "}
                        {/* Links */}
                        <div
                            className="nav flex-column nav-pills"
                            id="v-pills-tab"
                            role="tablist"
                            aria-orientation="vertical"
                        >
                            <a
                                className={`nav-link ${this.state.activeTab === "auto-mail" ? "active" : ""}`}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setState({ activeTab: "auto-mail" });
                                }}
                            >
                                E-Mails
                            </a>
                            <a
                                className={`nav-link ${this.state.activeTab === "mfa" ? "active" : ""}`}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setState({ activeTab: "mfa" });
                                }}
                            >
                                Zwei-Faktor-Authentifizierung
                            </a>
                            <a
                                className={`nav-link ${this.state.activeTab === "meta" ? "active" : ""}`}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setState({ activeTab: "meta" });
                                }}
                            >
                                Metafelder
                            </a>
                            <a
                                className={`nav-link ${this.state.activeTab === "update" ? "active" : ""}`}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setState({ activeTab: "update" });
                                }}
                            >
                                Release News
                            </a>
                        </div>
                    </div>
                    <div className="col pr-3">
                        {" "}
                        {/* Inhalt */}
                        <div className="tab-content" id="v-pills-tabContent">
                            <Suspense fallback={<div>Loading...</div>}>
                                {this.state.activeTab === "default" && (
                                    <p>
                                        Hier k&ouml;nnen Sie Einstellungen
                                        f&uuml;r E-Mail Trigger vornehmen.{" "}
                                        <br /> Aber auch sehen was die letzten
                                        Updated beinhaltet haben.
                                    </p>
                                )}
                                {this.state.activeTab === "auto-mail" && (
                                    <MailingSettings
                                        settings={this.state.MailSettings}
                                        firmenOptions={firmenBindungOptions}
                                    />
                                )}
                                {this.state.activeTab === "mfa" && (
                                    <>
                                        {this.state.isSuperAdmin && (
                                            <div className="mfa-firma-select mb-3">
                                                <label className="control-label">
                                                    Firma f&uuml;r
                                                    Zwei-Faktor-Authentifizierung
                                                </label>
                                                <Select
                                                    options={mfaFirmaOptions}
                                                    value={
                                                        this.state
                                                            .selectedMfaFirma
                                                    }
                                                    onChange={
                                                        this
                                                            .handleMfaFirmaChange
                                                    }
                                                    className="basic-select"
                                                    theme={selectTheme}
                                                />
                                            </div>
                                        )}
                                        <MfaSettings
                                            settings={this.state.MfaSettings}
                                            firmenId={
                                                this.state.selectedMfaFirma
                                                    ?.value || null
                                            }
                                            firmaLabel={
                                                this.state.selectedMfaFirma
                                                    ?.label || "Global"
                                            }
                                        />
                                    </>
                                )}
                                {this.state.activeTab === "meta" && (
                                    <>
                                        {this.state.isSuperAdmin && (
                                            <div className="mfa-firma-select mb-3">
                                                <label className="control-label">
                                                    Firma f&uuml;r Metafelder
                                                </label>
                                                <Select
                                                    options={mfaFirmaOptions}
                                                    value={
                                                        this.state
                                                            .selectedMetaFirma
                                                    }
                                                    onChange={
                                                        this
                                                            .handleMetaFirmaChange
                                                    }
                                                    className="basic-select"
                                                    theme={selectTheme}
                                                />
                                            </div>
                                        )}
                                        <MetaFieldsSettings
                                            firmenId={
                                                this.state.selectedMetaFirma
                                                    ?.value ?? null
                                            }
                                            firmaLabel={
                                                this.state.selectedMetaFirma
                                                    ?.label || "Global"
                                            }
                                        />
                                    </>
                                )}
                                {this.state.activeTab === "update" && (
                                    <UpdateNews />
                                )}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Einstellungen;
